var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.0513V3.85133L5.713 7.13833L4.30767 5.69233L10 0L15.6923 5.69233L14.287 7.13833L11 3.85133V15.0513H9ZM2.41033 20C1.73678 20 1.16667 19.7667 0.7 19.3C0.233333 18.8333 0 18.2632 0 17.5897V13.9743H2V17.5897C2 17.6923 2.04278 17.7863 2.12833 17.8717C2.21367 17.9572 2.30767 18 2.41033 18H17.5897C17.6923 18 17.7863 17.9572 17.8717 17.8717C17.9572 17.7863 18 17.6923 18 17.5897V13.9743H20V17.5897C20 18.2632 19.7667 18.8333 19.3 19.3C18.8333 19.7667 18.2632 20 17.5897 20H2.41033Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload2);
export default __webpack_public_path__ + "static/media/upload2.fdc9bac5272b2d741f3658818a4c96ff.svg";
export { ForwardRef as ReactComponent };